<template>
  <div class="einvoice-tax-breakdown">
    <b-table-simple small responsive class="einvoice-tax-breakdown-table mb-0">
      <b-thead>
        <b-tr>
          <b-th class="text-center col-rate">Thuế suất</b-th>
          <b-th class="text-right col-money">Tổng tiền hàng</b-th>
          <b-th class="text-right col-money">Tổng tiền thuế</b-th>
        </b-tr>
      </b-thead>

      <b-tbody v-if="rows.length">
        <b-tr v-for="(row, index) in rows" :key="buildRowKey(row, index)">
          <b-td class="text-center">{{ formatTaxLabel(row) }}</b-td>
          <b-td class="text-right col-number">{{ formatCurrency(row.totalBeforeTax) }}</b-td>
          <b-td class="text-right col-number">{{ formatCurrency(row.totalVat) }}</b-td>
        </b-tr>
      </b-tbody>

      <b-tbody v-else>
        <b-tr>
          <b-td colspan="3" class="text-center text-muted py-3">Không có dữ liệu</b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
  </div>
</template>

<script>
  export default {
    name: 'EInvoiceTaxBreakdownTable',

    props: {
      rows: {
        type: Array,
        default: () => [],
      },
    },

    methods: {
      formatCurrency(value) {
        if (value == null) return '0'
        return new Intl.NumberFormat('vi-VN').format(Number(value) || 0)
      },

      normalizeTaxCode(taxCode) {
        if (typeof taxCode !== 'string') return ''
        return taxCode.trim().toUpperCase()
      },

      resolveSpecialTaxCodeByRate(taxRate) {
        if (taxRate === -1) return 'KCT'
        if (taxRate === -2) return 'KKK'
        if (taxRate === -9) return 'XK'
        return ''
      },

      formatTaxRate(taxRate) {
        const specialTaxCode = this.resolveSpecialTaxCodeByRate(Number(taxRate) || 0)
        if (specialTaxCode) return specialTaxCode
        return `${Number(taxRate) || 0}%`
      },

      formatTaxLabel(row = {}) {
        const normalizedTaxCode = this.normalizeTaxCode(row.taxCode)
        const rateValue = Number(row.taxRate) || 0
        const rateLabel = this.formatTaxRate(rateValue)

        if (!normalizedTaxCode) {
          return rateLabel
        }

        const mappedCode = this.resolveSpecialTaxCodeByRate(rateValue)
        if (mappedCode && mappedCode === normalizedTaxCode) {
          return normalizedTaxCode
        }

        if (rateValue === 0) {
          return normalizedTaxCode
        }

        return `${rateLabel} (${normalizedTaxCode})`
      },

      buildRowKey(row = {}, index = 0) {
        const taxRate = Number(row.taxRate) || 0
        const taxCode = this.normalizeTaxCode(row.taxCode)
        return `${taxRate}::${taxCode || 'none'}::${index}`
      },
    },
  }
</script>

<style lang="scss" scoped>
  .einvoice-tax-breakdown-table {
    border-collapse: collapse;
    width: 100%;
    background: #fff;

    thead th {
      padding: 0.72rem 0.52rem;
      border: 1px solid #dbe3ea;
      background: #f6f8fb;
      color: #607082;
      font-size: 0.7rem;
      font-weight: 700;
      letter-spacing: 0.05em;
      line-height: 1.25;
      text-transform: uppercase;
    }

    td {
      padding: 0.74rem 0.52rem;
      border: 1px solid #e3e8ee;
      background: #fff;
      color: #334155;
      vertical-align: middle;
      line-height: 1.35;
    }

    tbody tr:nth-child(even) td {
      background: #fbfdff;
    }
  }

  .col-rate {
    width: 110px;
  }

  .col-money {
    width: 170px;
  }

  .col-number {
    font-variant-numeric: tabular-nums;
    color: #1f2937;
  }

  @media (max-width: 991.98px) {
    .einvoice-tax-breakdown-table {
      thead th {
        padding: 0.62rem 0.48rem;
      }

      td {
        padding: 0.64rem 0.48rem;
      }
    }
  }
</style>
